import { render, staticRenderFns } from "./QuoteBuilderPartComponent.vue?vue&type=template&id=edaede78&scoped=true"
import script from "./QuoteBuilderPartComponent.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderPartComponent.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderPartComponent.vue?vue&type=style&index=0&id=edaede78&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edaede78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edaede78')) {
      api.createRecord('edaede78', component.options)
    } else {
      api.reload('edaede78', component.options)
    }
    module.hot.accept("./QuoteBuilderPartComponent.vue?vue&type=template&id=edaede78&scoped=true", function () {
      api.rerender('edaede78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/ItemTypeComponents/quoteBuilderParts/QuoteBuilderPartComponent.vue"
export default component.exports